import { Accordion, AccordionHeader, AccordionBody } from "@material-tailwind/react";
import ReLandUseAccordionBody from "./components/ReLandUseAccordionBody";
import ReForestLossAccordionBody from "./components/ReForestLossAccordionBody";
import { useEffect, useState } from "react";
import { DataLayerTypes } from "../../../types/enums";
import { useCurrentDataLayerTypeSelector } from "../../../store/projects/selectors";
import { setCurrentDataLayerType } from "../../../store/projects/actions";
import { dispatch } from "../../../store";
import ReBioDiversityAccordionBody from "./components/ReBioDiversityAccordionBody";
import ReCanOpyHeightAccordionBody from "./components/ReCanOpyHeightAccordionBody";
import ReDemAccordionBody from "./components/ReDemAccordionBody";
import ReBioMassAccordionBody from "./components/ReBioMassAccordionBody";

const ReProjectSpecificParameter = () => {
  const currentDataLayerType = useCurrentDataLayerTypeSelector();
  const [open, setOpen] = useState(1);

  const layerTypes = [
    { value: DataLayerTypes.LULC, openNumber: 1 },
    { value: DataLayerTypes.BIO_DIVERSITY, openNumber: 2 },
    { value: DataLayerTypes.FOREST_LOSS, openNumber: 3 },
    { value: DataLayerTypes.CANOPY_HEIGHT, openNumber: 4 },
    { value: DataLayerTypes.DEM, openNumber: 5 },
    { value: DataLayerTypes.ECO_REGIONS, openNumber: 6 },
    { value: DataLayerTypes.ESA_CCI_BIOMASS, openNumber: 7 },
    { value: DataLayerTypes.PROTECTED_AREA_FOREST, openNumber: 8 },
  ];

  // useEffect hook to handleOpen
  useEffect(() => {
    if (currentDataLayerType) {
      const layerType = layerTypes?.find((layer) => layer.value === currentDataLayerType);
      if (layerType) {
        setOpen(layerType.openNumber);
      } else {
        console.log("error");
      }
    }
  }, [currentDataLayerType]);

  // function to handle open
  const handleOpen = (layerNumber: number) => {
    const layer = layerTypes?.find((layer) => layer.openNumber === layerNumber);
    setOpen(open === layerNumber ? 0 : layerNumber);
    dispatch(setCurrentDataLayerType(layer?.value || "lulc"));
  };

  const Icon = ({ id, open }: any) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={2}
        stroke="currentColor"
        className={`${id === open ? "rotate-180" : ""} h-5 w-5 transition-transform`}
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
      </svg>
    );
  };

  return (
    <div className="max-h-full max-w-full rounded-lg bg-white shadow-md">
      <h3 className="p-4 text-lg font-medium">Project Specific Parameters</h3>
      <div className="h-[0.5px] w-full bg-gray-300"></div>
      <div className="p-4 font-primary">
        {/* accordion view */}
        <Accordion placeholder={""} open={open === 1} icon={<Icon id={1} open={open} />}>
          <AccordionHeader
            placeholder={""}
            onClick={() => handleOpen(1)}
            className="text-md font-medium text-black"
          >
            <span className="font-primary">Land use</span>
          </AccordionHeader>
          <AccordionBody>
            <ReLandUseAccordionBody />
          </AccordionBody>
        </Accordion>
        <Accordion placeholder={""} open={open === 2} icon={<Icon id={2} open={open} />}>
          <AccordionHeader
            placeholder={""}
            onClick={() => handleOpen(2)}
            className="text-md font-medium text-black"
          >
            <span className="font-primary">Biodiversity Significance and Inexactness</span>
          </AccordionHeader>
          <AccordionBody>
            <ReBioDiversityAccordionBody />
          </AccordionBody>
        </Accordion>
        <Accordion placeholder={""} open={open === 3} icon={<Icon id={3} open={open} />}>
          <AccordionHeader
            placeholder={""}
            onClick={() => handleOpen(3)}
            className="text-md font-medium text-black"
          >
            <span className="font-primary">Forest Loss</span>
          </AccordionHeader>
          <AccordionBody>
            <ReForestLossAccordionBody />
          </AccordionBody>
        </Accordion>
        <Accordion placeholder={""} open={open === 4} icon={<Icon id={4} open={open} />}>
          <AccordionHeader
            placeholder={""}
            onClick={() => handleOpen(4)}
            className="text-md font-medium text-black"
          >
            <span className="font-primary">Canopy Height</span>
          </AccordionHeader>
          <AccordionBody>
            <ReCanOpyHeightAccordionBody />
          </AccordionBody>
        </Accordion>
        <Accordion placeholder={""} open={open === 5} icon={<Icon id={5} open={open} />}>
          <AccordionHeader
            placeholder={""}
            onClick={() => handleOpen(5)}
            className="text-md font-medium text-black"
          >
            <span className="font-primary">Dem</span>
          </AccordionHeader>
          <AccordionBody>
            <ReDemAccordionBody />
          </AccordionBody>
        </Accordion>
        <Accordion placeholder={""} open={open === 7} icon={<Icon id={7} open={open} />}>
          <AccordionHeader
            placeholder={""}
            onClick={() => handleOpen(7)}
            className="text-md font-medium text-black"
          >
            <span className="font-primary">Biomass</span>
          </AccordionHeader>
          <AccordionBody>
            <ReBioMassAccordionBody />
          </AccordionBody>
        </Accordion>
      </div>
    </div>
  );
};

export default ReProjectSpecificParameter;
